module.exports = __webpack_public_path__ + "b9fbd12f223bac42283fa8f3f0245402.pdf";